import React, { useState, useEffect } from 'react';
import styled from "styled-components"
import closeIcon from "../../../assets/imgs/close-new.svg";

const RechargeOverlay = (props) => {

  let planData=props.data;

  const [selectedTabIndex,setSelectedTabIndex] = useState(0);
  const [overlayHeight, setOverlayHeight] = useState(0);
  const [tabWrapperPosition,setTabWrapperPosition] = useState(0);

 // let overlayHeight = 0
  

  const handleCancel = () => { //close overlay screen
    props.overlayRechargeToggle();
  }

  const handlePlanOnclick =(sendData)=> {

    props.overlayRechargeToggle();//close overlay screen and sendData backend and autosubmit on UI

    let inputString =   '₹ ' + sendData + "<split>" + sendData;
    window['autosubmit'](inputString);


  }

  useEffect(()=>{

    document.getElementById('tab-link'+selectedTabIndex).style.background = '#ddd';
    document.getElementById('tab-link'+selectedTabIndex).style.borderBottom = '3px solid #2c387a';

    let sfOverlayBlock=document.getElementById("sf-overlayBlock");
     
    if(sfOverlayBlock){
    setOverlayHeight(document.getElementById("sf-overlayBlock").getBoundingClientRect().height-200);
    }
    
    window.addEventListener('resize', handleResize);

  },[selectedTabIndex,overlayHeight]);

  
   const handleResize = () => {

    let sfOverlayBlock=document.getElementById("sf-overlayBlock");
     
    if(sfOverlayBlock){

      setOverlayHeight(document.getElementById("sf-overlayBlock").getBoundingClientRect().height-200);
    }

  }
    
  const handleTabSelect =(selectedTab,index)=>{

//** */     

  // let selectedTabWidth = document.getElementById(selectedTab).getBoundingClientRect().width;
  // let selectedTabX = document.getElementById(selectedTab).offsetLeft;
  // let selectedTabXDOM = document.getElementById(selectedTab).getBoundingClientRect().x;
  // let botWidth = document.getElementById("sf-chat-main-container").getBoundingClientRect().width;
  // let botDOMX = document.getElementById("sf-chat-main-container").getBoundingClientRect().x;
  // console.log("Tab width: ",selectedTabWidth, "offset left: ",selectedTabX, "bot width: ",botWidth); 

  // botDOMX+botWidth

  // selectedTabXDOM


  // if((selectedTabXDOM) > (botDOMX+botWidth)){
  //       setTabWrapperPosition(tabWrapperPosition - selectedTabWidth );
      

  // }else if (selectedTabX <=0){
  //   console.log("else called")
    // setTabWrapperPosition(tabWrapperPosition + selectedTabWidth)
 // }






//** */
     setSelectedTabIndex(index); 

  }

//css *****TabBlock*******
 
  const TabBlock=styled.div`

  .sf-tab-wrapper {
    width:100%;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none; 
    background: #f1f1f1;
    position:relative;

// //for scroll
//     height:48px;
//     overflow:hidden;
//     overflow-x:scroll;
    //try
    //  scroll-behavior: smooth;

  }

  .sf-tab-wrapper::-webkit-scrollbar {
    display: none;
  }
  
  .sf-tab {
    background-color: #f1f1f1;
    //margin-bottom:24px;
    position:relative;
 

  //for scroll
    // width:500px;
    // height:48px;
   // background:red;
   
   
  }

  .sf-tablinks {
    background-color: #f1f1f1
    display: inline-block;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    font-size: 15px;
    box-sizing: border-box;
    transform:translateX(${tabWrapperPosition}px);
    transition: all 1s;
    
   
  }

  .tab button:hover {
    background-color: rgba(221,221,221,0.5);
  }

  // .tab button.active {
  //   background-color: #ccc;
  // }

  .sf-tabcontent {
    padding:20px;
    color: #888;
    width:90%;
    margin:16px 5% 0px 5%;
    background:#fff;
    border-radius:8px;
    box-shadow: 0px 8px 8px rgba(0,0,0,0.1);
  }

  .sf-plan-title{
    margin-bottom: 10px;
  }

  .sf-plan-desc{
    display: inline-block;
    width:65%;
    vertical-align: middle;
    font-size:12px;
  }

  .sf-plan-amount{
    display: inline-block
    width: 32% 
  }

//***********************************//

  .sf-tab-content-block{
    width: 100%;
    // background:red;
    height:${overlayHeight}px;
    overflow:scroll;
    padding-bottom: 20px ;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none; 

  }

  .sf-tab-content-block::-webkit-scrollbar {
    display: none;
  }

`
//

  return (
    <OverlayBlock id="sf-overlayBlock">
    <MainBlock>
        <div style={{background:'#fff'}}>
           <TitleBlock>Select a plan to proceed further</TitleBlock>
           <CloseBlock onClick={() => handleCancel()}>
             <img src={closeIcon} />
           </CloseBlock>
        </div>

       <TabBlock>

         <div className="sf-tab-wrapper">
          <div className="sf-tab">
            {planData.map((item,i)=>{
                return(
                  <button className="sf-tablinks" key={i} id={'tab-link'+i} 
                      onClick = {()=> handleTabSelect('tab-link'+i,i)}>{item.category}
                  </button>
                )})
            }
          </div>
         </div>

         <div className="sf-tab-content-block">
            {planData[selectedTabIndex].plans.map((item,i)=>{
              return(
              <div key={i} className="sf-tabcontent">
                <div className="sf-plan-title">Talktime: <span style={{fontWeight:"500", color: "black"}}>₹ {item.talktime}</span></div>
                <div>
                  <div className="sf-plan-desc">{item.plan_description}</div>
                  <div className="sf-plan-amount"><ActionButton
                    onClick={()=> handlePlanOnclick(item.amount)}
                  >₹ {item.amount}</ActionButton></div>
                </div>
              </div>
              )
             })
            }
         </div>

       </TabBlock>

    </MainBlock>
    </OverlayBlock>
  );
}



const OverlayBlock=styled.div`
  height: 100%;
  width:100%;
  position:absolute;
  background:rgba(0,0,0,0.2);
  z-index: 100;
`
const MainBlock=styled.div`
  height: 100%;
  width: 100%;
  position:relative;
  background: #ddd;
  font-size:15px;
  background:#fcfcfc;
`
const TitleBlock=styled.div`
  padding: 20px; 
  display: inline-block; 
  fontWeight: 600px;
  font-size:16px;
`
const CloseBlock=styled.div`
  float: right;
  cursor: pointer;
  margin:20px;
  display: inline-block;
  opacity:0.4;
`
const ActionButton = styled.div`
    border: 0px solid #2c387a;
    border-radius: 6px;
    background: #2c387a;
    padding: 10px 12px;
    text-align: center;
    color: #fff;
    vertical-align: middle;
    width: 90%;
    margin: 22px;
    cursor: pointer;
//   max-width: 200px;
//   margin: 10px auto;
//   line-height:36px;
`

export default RechargeOverlay;